import { createAction } from 'redux-actions';

export const UPDATE_SUBMODULE_VALIDITY = 'UPDATE_SUBMODULE_VALIDITY';

export const updateSubmoduleValidity = createAction(UPDATE_SUBMODULE_VALIDITY);
